import styled from "styled-components";
import { COLOURS, BORDERS } from "../../variables/Colors";
import { BREAKPOINTS, desktop } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";

export const Headline = styled.h3`
  font-family: gantmodern-regular;
  font-weight: 400;
  font-size: 1rem;
  color: ${COLOURS.primary.black};
  margin: 0;
  text-align: left;
  opacity: 0;
`;

export const Subheading = styled.h4`
  font-family: gantserif-medium-condensed;
  font-weight: 400;
  font-size: 1.5rem;
  color: ${COLOURS.primary.black};
  margin: 0;
  text-align: left;
  .sponsored {
    font-size: 0.8rem;
    line-height: 0.8rem;
  }
  opacity: 0;
  ${props => props.$margin && `margin-top: 0.5rem;`};
`;

export const LandingWrapper = styled.div`
  ${setPosition({ position: "relative", top: "0" })};
  ${setFlex({ justify: "flex-start", align: "center", direction: "column" })};
  min-height: 100vh;
`;

export const Wrapper = styled.div`
  ${setPosition({ position: "absolute", top: "0" })};
  ${setFlex({ justify: "flex-start", align: "center", direction: "column" })};
  height: 100vh;
  width: 100%;
  &.gant--landing-section {
    ${setPosition({ zIndex: 50 })};
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: auto;
  }
  &:not(.active) {
    height: 0px;
    min-height: 0px;
  }
`;

export const LandingTextWrapper = styled.div`
  ${setFlex({ direction: "column" })};
  width: 50%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
  }
`;

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const Image = styled.img`
  width: auto;
  max-width: 80vw;
`;

export const OverlayContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${props =>
    setFlex({
      justify: props.$justify,
      align: props.$align,
      direction: props.$direction,
    })};
  ${props => props.$zIndexBoost && "z-index: 6;"};
  ${props => props.$border && `border: 1px solid ${BORDERS.secondary}`};
  min-height: 100vh;
  height: 100%;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ align: "flex-start" })};
    min-height: -webkit-fill-available;
    height: -webkit-fill-available;
    min-height: -moz-available;
    height: -moz-available;
  }
  will-change: transform;
`;

export const FrostBackdrop = styled.div`
  ${setPosition({ position: "relative", zIndex: 1 })};
  ${setFlex({ justify: "center", align: "center" })};
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: inherit;
  overflow: hidden;
  will-change: transform;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-height: 100vh;
  }
  &:before {
    ${setPosition({
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      zIndex: -1,
    })};
    content: "";
    background: inherit;
    backdrop-filter: blur(${props => props.$blurAmount}px);
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-backdrop-filter: blur(${props => props.$blurAmount}px);
    background: linear-gradient(
      88deg,
      rgba(255, 255, 255, 0.1) 51.69%,
      rgba(255, 255, 255, 0) 150.79%
    );
    border: 1px solid ${BORDERS.secondary};
    will-change: transform;
  }
`;

export const Row = styled.div`
  ${setFlex({ align: "flex-start" })};
  width: 100%;
  height: fit-content;
  padding: 0 5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "center", direction: "column" })};
    min-height: 100vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "center" })};
    padding: 5rem 2.5rem;
  }
`;

export const TextWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  width: 50%;
  height: fit-content;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding-bottom: 5rem;
    width: 100%;
  }
`;
